export default __webpack_public_path__ + "static/media/132.85e0b0df.webp";